import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import PopUp from "../PopUp";
import api from "../api/api";
import functions from "../../functions/functions";

export default function FidelityDiscountsPopup() {
	const {
		cart,
		setFidelityDiscountsPopupVisible,
		setCart,
		setLoading,
		points,
		pointsGained,
		setPointsGained,
		pointsSpent,
		setPointsSpent,
	} = useContext(AppContext);
	const [discounts, setDiscounts] = useState([]);

	useEffect(() => {
		setLoading(true);
		load_discounts();
		setLoading(false);
	}, []);

	async function load_discounts() {
		const response = await api.post("/discounts_fidelity/list/", { orderby: "points" });
		if (response.success == 0) alert(response.error);
		else setDiscounts(response.rows);
	}

	const handleClick = (discount) => {
		let nCart = { ...cart };
		nCart.discounts.push({
			name: discount.name,
			type: "fidelity",
			value_type: discount.value_type,
			value: discount.value,
			points: discount.points,
		});
		setCart(nCart);
		setFidelityDiscountsPopupVisible(false);
	};

	const getValueLabel = (discount) => {
		if (discount.value_type === "fixed") {
			return <div>Valore: {functions.formatter.format(discount.value)}</div>;
		}
		if (discount.value_type === "product") {
			return null;
		}
		if (discount.value_type === "perc") {
			return <div>Valore: {discount.value}%</div>;
		}
		return null;
	};

	const getPointSale = () => {
		if (!cart.order_id) return parseInt(points);
		else {
			return (
				parseInt(points) +
				Math.abs(parseInt(cart.pointsSpent)) -
				parseInt(cart.pointsGained)
			);
		}
	};

	return (
		<PopUp
			size="sm"
			options={{
				onClose: () => setFidelityDiscountsPopupVisible(false),
				title: "Sconti Fidelity",
				content: (
					<div className="discount">
						<div className="container">
							<p>Cliente: {cart.customer.surname + " " + cart.customer.name}</p>
							<p>
								Saldo punti: <b>{getPointSale()}</b>
							</p>
							<div className="buttons-fidelity">
								{discounts.map(
									(discount, i) =>
										discount.value_type !== "product" &&
										getPointSale() >= parseInt(discount.points) && (
											<button
												className="button button-1"
												key={i}
												onClick={() => handleClick(discount)}
											>
												<div className="main">{discount.name}</div>
												<div className="sub">
													<div>Punti necessari: {discount.points}</div>
													{getValueLabel(discount)}
												</div>
											</button>
										)
								)}
							</div>
						</div>
					</div>
				),
			}}
		/>
	);
}
